import { map } from 'rxjs/operators'
import http from '../helpers/http'
import httpDelete from '../helpers/httpDelete'

const getThickness = (params : object) => {
  // console.log('get ship type called in type service')
  return http({
    method: 'GET',
    url: '/thickness/list',
    params
  }).pipe(
    map(res => {
      // console.log(res,'response in type service')
      if (res.success) {
        return res
      } else {
        throw new Error(res.msg)
      }
    })
  )
}

const addThickness = (body : any) => {
  return http({
    method: 'POST',
    url: '/thickness',
    body
  }).pipe(
    map(res => {
      if (res.success) {
        return res
      } else {
        throw new Error(res.msg)
      }
    })
  )
}

const getThicknessDetail = (id : any) => {
  return http({
    method: 'GET',
    url: `/thickness/${id}`
  }).pipe(
    map(res => {
      // console.log(res,'get ship detail')
      if (res.success) {
        return res
      } else {
        throw new Error(res.msg)
      }
    })
  )
}

const deleteThickness = (id : any) => {
  return httpDelete({
    method: 'DELETE',
    url: `/thickness/${id}`,
  }).pipe(
    map(res => {
      // console.log(res,'delete response')
      if (res) {
        return res
      } else {
        // console.log(res,'error message')
        throw new Error(res)
      }
    })
  )
}

const updateThickness = (body : any) => {
  return http({
    method: 'PUT',
    url: '/thickness',
    body
  }).pipe(
    map(res => {
      if (res.success) {
        // console.log(res)
        return res
      } else {
        // console.log(res,res.msg)
        throw new Error(res.msg)
      }
    })
  )
}

const thicknessService = {
  getThickness,
  addThickness,
  getThicknessDetail,
  deleteThickness,
  updateThickness, 
}
  
export default thicknessService
  

